import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import StallTypeLayer from '../components/StallTypeLayer';

const StallTypePage = () => {
    return (
        <MasterLayout>
            <StallTypeLayer />
        </MasterLayout>
    );
};

export default StallTypePage;
